var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.504,
    height: 29.602,
    viewBox: "0 0 23.504 29.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(-1.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M76.239,26.959A2.646,2.646,0,0,1,73.591,29.6H55.383a2.646,2.646,0,0,1-2.648-2.643V2.643A2.646,2.646,0,0,1,55.383,0H66.718a1.988,1.988,0,0,1,1.406.582l7.535,7.536a1.98,1.98,0,0,1,.58,1.4Z",
    transform: "translate(-51.455 0)",
    fill: "#895aa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M317.357,11.62h-6.729a1.791,1.791,0,0,1-1.79-1.791V3.1a1.967,1.967,0,0,1,.582.4l7.535,7.536a1.967,1.967,0,0,1,.4.581Z",
    transform: "translate(-292.751 -2.922)",
    fill: "#ac71b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_814_",
    transform: "translate(6.799 14.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_764_",
    d: "M183.226,333.1v1.225H184v1.063h-.773v2.252a.553.553,0,0,0,.108.382.387.387,0,0,0,.29.116,1.288,1.288,0,0,0,.188-.009c.05-.008.108-.017.183-.033l.108,1.138a3.337,3.337,0,0,1-.416.083,3.41,3.41,0,0,1-.44.025,1.53,1.53,0,0,1-1.155-.407,1.761,1.761,0,0,1-.39-1.279v-2.262H181v-1.068h.69V333.1h1.537Z",
    transform: "translate(-181 -333.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_766_",
    d: "M231.351,349.246h.025L232,347.8h1.719l-1.42,2.426,1.479,2.483h-1.719l-.66-1.495h-.024l-.66,1.495H229l1.479-2.483L229.05,347.8h1.712Z",
    transform: "translate(-225.012 -346.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_768_",
    d: "M296.109,333.1v1.225h.773v1.063h-.773v2.252a.553.553,0,0,0,.108.382.387.387,0,0,0,.29.116,1.288,1.288,0,0,0,.189-.009c.05-.008.108-.017.183-.033l.108,1.138a3.341,3.341,0,0,1-.416.083,3.415,3.415,0,0,1-.44.025,1.53,1.53,0,0,1-1.155-.407,1.761,1.761,0,0,1-.39-1.279v-2.262H293.9v-1.068h.69V333.1h1.52Z",
    transform: "translate(-284.521 -333.1)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.c436d66200549157b810a1128a412f70.svg";
export { ForwardRef as ReactComponent };